// Ignore list based off: https://gist.github.com/1878283
function googleTagManager() {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-K8TC847');
}

// Run all of the above
function runAllFunctions() {
  let buildNumber = '"jenkins-frontend-builds-base-frontend-build-58122"';
  let env = '"frontend-builds/base-frontend-build"';
  let googleAnalyticsKey = 'UA-31203397-3';

  googleTagManager();
}

runAllFunctions();
